import SSO from './SSO-view';

export default SSO;
